import React, { useState, useEffect } from "react";
import OtpInput from 'react-otp-input';
import PostApiCall from "../../Api/Api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { delay } from '../../Helper/ToastDelay';
import Notiflix from "notiflix";
import { CandidateAlreadyRegitered, InvalidOtp, SomethingWrong } from "../../Helper/ErrorMessages";
import moment from 'moment';
import { useNavigate } from "react-router-dom";

const VerifyMobile = () => {
  const [OtpEntered, setOtpEntered] = useState('');
  const [UserData, setUserData] = useState(null);
  const history=useNavigate()

  useEffect(() => {
    Notiflix.Loading.init({ svgColor: "#c16d18" });

    const data = JSON.parse(localStorage.getItem('VerifyUser'));
    if (data !== null) {
      setUserData(data);
    } else {
      // window.location.href = '/register';
      history("/register")
    }
  }, []);

  const onVerifyClicked = () => {
    if (OtpEntered === '000000') {
      PostApiCall.postRequest({
        name: UserData.Name,
        email: UserData.Email,
        mobile: UserData.Mobile,
        mobileverified: 'Yes',
        updatedon: moment().format('ll'),
        addedon: moment().format('ll'),
        
      }, "RegisterCandidate").then(resultdes => resultdes.json().then(obj => {
        if (resultdes.status === 200 || resultdes.status === 201) {
          localStorage.removeItem('VerifyUser');
          Notiflix.Report.success('Registered!', 'Thank you for registering with us. An email has been sent to you, kindly confirm your email.', 'Ok', () => {
            window.location.href = '/login';
          });
        } else {
          if (obj.data === 'Already Registered') {
            toast.error(CandidateAlreadyRegitered, {
              autoClose: delay,
              toastId:1
            });
          } else {
            toast.error(SomethingWrong, {
              autoClose: delay,
              toastId:1
            });
          }
        }
      }));
    } else {
      toast.error(InvalidOtp, {
        autoClose: delay
      });
    }
  };

  return (
    <div className="App">
      <ToastContainer />
      <div className="page-header">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="inner-header">
                <h3>Verify Phone Number</h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section id="content" className="section-padding">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-5 col-md-6 col-xs-12">
              <div className="page-login-form box">
                <h3>
                  Verify Mobile
                  <p style={{
                    fontSize: '14px',
                    fontWeight: 'normal',
                    textTransform: 'initial'
                  }}>OTP has been sent to your mobile number <br /><b>{UserData && UserData.Mobile}</b> <br /> Kindly enter OTP to register.</p>
                </h3>
                <form className="login-form" onSubmit={(e) => { e.preventDefault(); }}>
                  <div className="form-group otp-login">
                    <OtpInput
                      value={OtpEntered}
                      onChange={(e) => setOtpEntered(e)}
                      numInputs={6}
                      renderSeparator={<span>&nbsp;&nbsp;&nbsp;</span>}
                      renderInput={(props) => <input {...props} />}
                    />
                  </div>
                  <button className="btn btn-common log-btn mt-3" onClick={onVerifyClicked}>Register</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default VerifyMobile;
